(function() {
    'use strict';
    angular
        .module('telestatApp')
        .factory('MegafonInternalPhonesService', MegafonInternalPhonesService);

    MegafonInternalPhonesService.$inject = ['$resource'];

    function MegafonInternalPhonesService ($resource) {
        var resourceUrl =  'api/pbx/megafon';

        return $resource(resourceUrl, {}, {
            'getinternal': {
                method: 'GET',
                url: 'api/megafon-internal-phones',
                transformResponse: function (data) {
                    if (data) {
                        data = angular.fromJson(data);
			const filteredData = [];
			for (var i = 0; i < data.length; i++) {
			    if (data[i].ri != undefined && data[i].ri.reginfo != undefined && data[i].ri.reginfo.length > 0){
				filteredData.push(data[i]);
			    }
			}
			data = filteredData;
                    }
                    return data;
                },
                isArray: true
            }/*,
            'getfreeCsv': {
                method: 'GET',
                url: 'api/pbx/megafon/getfree-csv'
            },
            'setLockTime': {
                method:'POST',
                url: 'api/pbx/megafon/set-locktime'
            },
            'moveToLocked': {
                method:'POST',
                url: 'api/pbx/megafon/move-to-locked'
            },
            'moveToSim': {
                method:'POST',
                url: 'api/pbx/megafon/move-to-sim'
            }*/
        });
    }
})();
